import { Key } from './Key';
import { Spacer } from './styled';
export function Legend(props) {
    const { progress } = props;
    return (<Spacer>
      {progress.map(state => (<Key key={state.appearance} {...state}/>))}
    </Spacer>);
}
